export const runEditProgramRequestFlow = async ({
    request,
    files,
    onError,
    updateRequest,
    uploadFiles,
}) => {
    try {
        const result = await updateRequest(request, onError);
        if (!result) return false;

        if (files?.length) {
            await uploadFiles(files, request.requestId);
        }

        return true;
    } catch (error) {
        if (onError) onError(error);
        return false;
    }
};
